<div class="overlay">
  <app-map-control [overlay]="true" class="map-control"></app-map-control>
</div>
